import HelpIcon from "@mui/icons-material/Help";
import IconButton from "@mui/material/IconButton";
import Tooltip from "@mui/material/Tooltip";

export default function ToolTip({
	fontSize = "medium",
	size = "20px",
	tip,
	placement = "top",
	sx,
}) {
	return (
		<Tooltip title={tip} placement={placement} arrow>
			<IconButton sx={{ p: 0, ...sx }}>
				<HelpIcon fontSize={fontSize} sx={{ height: size, width: size }} />
			</IconButton>
		</Tooltip>
	);
}
